import { useProjectBoard } from "@timenotes/shared/src/features/project-board";
import { useProjectSectionsQuery } from "@timenotes/shared/src/services/project-sections/queries/use-project-sections-query"
import { Select } from "antd";
import { useQueryClient } from "react-query";


interface Props extends React.ComponentProps<typeof Select> {
  projectId: string
}

export const ProjectSectionSelect = (props: Props) => {
  const {
    projectId
  } = props


  const {
    tasksFilters,
  } = useProjectBoard()

  // Use current board project sections with staleTime infinity to never fetch new ones
  // on the select level if those exists, no matter what is the general cache rule!
  const { projectSectionsQuery } = useProjectSectionsQuery({
    projectId: projectId,
    filters: tasksFilters
  }, {
    staleTime: Infinity,
  })

  const projectSections = projectSectionsQuery.data?.projectSections || []

  const options = projectSections.map((projectSection) => {
    return (
      {
        label: projectSection.name,
        value: projectSection.id,
      }
    )
  })

  return (
    <Select 
      style={{
        width: '300px'
      }}
      showSearch
      optionFilterProp="label"
      options={options}
      {...props}
    />
  )
}